"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _getBorderColor = _interopRequireDefault(require("./utils/getBorderColor"));
var _getInputBorderRadius = _interopRequireDefault(require("./utils/getInputBorderRadius"));
var _getInputBorderWidth = _interopRequireDefault(require("./utils/getInputBorderWidth"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getPadding = function getPadding(_ref) {
  var fixed = _ref.fixed,
    theme = _ref.theme,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    withPrefix = _ref.withPrefix,
    withSuffix = _ref.withSuffix,
    isReadOnly = _ref.isReadOnly;
  if (fixed || iconLeft && iconRight || theme.prefixSuffixInsideInput && withPrefix && withSuffix) {
    return '0';
  }
  if (iconLeft || theme.prefixSuffixInsideInput && withPrefix) {
    return "0 ".concat(theme.horizontalSpacing, " 0 0");
  }
  if (iconRight || theme.prefixSuffixInsideInput && withSuffix) {
    return "0 0 0 ".concat(theme.horizontalSpacing);
  }
  if (isReadOnly) {
    return "".concat(theme.horizontalSpacingReadOnly);
  }
  return "0 ".concat(theme.horizontalSpacing);
};
var InputFieldWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  margin: ", ";\n  padding: ", ";\n  transition: border-color ", "\n    ease-in-out;\n"])), function (_ref2) {
  var theme = _ref2.theme,
    withPrefix = _ref2.withPrefix,
    withSuffix = _ref2.withSuffix,
    focused = _ref2.focused,
    isReadOnly = _ref2.isReadOnly;
  return (0, _getInputBorderWidth["default"])({
    theme: theme,
    withSuffix: withSuffix,
    withPrefix: withPrefix,
    focused: focused,
    isReadOnly: isReadOnly
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderStyle;
}, _getBorderColor["default"], function (_ref4) {
  var theme = _ref4.theme,
    withSuffix = _ref4.withSuffix,
    withPrefix = _ref4.withPrefix;
  return (0, _getInputBorderRadius["default"])({
    theme: theme,
    withSuffix: withSuffix,
    withPrefix: withPrefix
  });
}, function (_ref5) {
  var theme = _ref5.theme,
    isReadOnly = _ref5.isReadOnly;
  return isReadOnly ? "0 0 0 -".concat(theme.borderWidth) : 0;
}, getPadding, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderTransitionTiming;
});
InputFieldWrapper.displayName = 'InputFieldWrapper';
var _default = InputFieldWrapper;
exports["default"] = _default;